<template>
  <!--我的订单-->
  <div class="orders">
    <!-- <div v-show="$route.meta.navShow"> -->
    <div class="titleWrap">
      <p class="titleName">我的证书 > 全国物业行业项目经理职业资格证书</p>
    </div>
    <p class="img"  style="display: none;"><img src="../../assets/zhengshu4.png" alt=""></p>
    <p class="img"><img src="../../assets/zhengshu5.png" alt=""></p>
    <p >
      <router-link to="/ziliao/zhengshurending">学分认定</router-link>
      <router-link to="/">证书换新</router-link>
    </p>
    <p style="display: none;">
      <router-link to="/" class="one">证书换新</router-link>
    </p>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #083C68;
    .titleName {
      float: left;
      line-height: 24px;
      padding-bottom: 13px;
    }
  }
  .img{
    padding: 50px;
  }
  a{
    color: #fff ;
    font-size: 16px;
    background-color: #957960;
    display: inline-block;
    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px;
    margin: auto;
    &:first-child{
      margin:0 50px 0 130px;
    }
  }
  p .one{
    display: block;
    margin: 0 auto;
  }



</style>
<script type="text/ecmascript-6">
  import centers from '../template/center'
  export default {
    name: 'orderdetail',
    props: {},
    data() {
      return {


      };
    },
    methods: {

    },
    created() {

    },
    components: {
      centers
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/center/zhengshudetail.vue